export default __webpack_public_path__ + "static/media/header_background.35a4eb7f.png";